export enum WidgetFlag {
  SHOW_SPINNER_INNER = 'show_spinner_inner',
  SHOW_SPINNER_OUTER = 'show_spinner_outer',

  HAS_TRANSACTION_INFO = 'has_transaction_info',
  HAS_SUBSCRIPTION_INFO = 'has_subscription_info',
  HAS_CUSTOMER_INFO = 'has_customer_info',
  HAS_EPMS_PAYMENT_INFO = 'has_epms_payment_info',
  HAS_EPMS_SUBSCRIPTION_INFO = 'has_epms_subscription_info',
  HAS_EPMS_PAYMENT_SOURCE_INFO = 'has_epms_payment_source_info',

  TRANSACTION_NOT_FOUND = 'transaction_not_found',
  SUBSCRIPTION_NOT_FOUND = 'subscription_not_found',
  CUSTOMER_INFO_NOT_FOUND = 'customer_info_not_found',

  PAYMENT_ABORTED = 'payment_aborted',

  EPMS_PAYMENT_NOT_FOUND = 'epms_payment_not_found',
  EPMS_SUBSCRIPTION_NOT_FOUND = 'epms_subscription_not_found',
  EPMS_PAYMENT_SOURCE_NOT_FOUND = 'epms_payment_source_not_found',

  HAS_EPMS_PAYMENT_REQUEST_DATA = 'has_epms_payment_request_data',
  HAS_EPMS_PAYMENT_RESPONSE_DATA = 'has_epms_payment_response_data',
  HAS_EPMS_PAYMENT_RESPONSE_ERROR = 'has_epms_payment_response_error',

  SHOW_OVERLAY_DATA_PROTECTION_POLICY = 'show_overlay_data_protection_policy',
  SHOW_OVERLAY_SMS_POLL = 'show_overlay_sms_poll',

  PREVENT_PAYMENT_VALIDATE_AND_SEND = 'prevent_payment_validate_and_send',
}

export const WidgetOverlayFlags: WidgetFlag[] = [
  WidgetFlag.SHOW_OVERLAY_DATA_PROTECTION_POLICY,
  WidgetFlag.SHOW_OVERLAY_SMS_POLL,
]
